import { createBigDecimal } from '@0xtorch/big-decimal'
import { z } from 'zod'
import { decimalSchema } from '../../utils/schema'

export const coinInfoSchema = z.object({
  /** e.g. "BTC" */
  coin: z.string(),
  /** e.g. true */
  depositAllEnable: z.boolean(),
  /** e.g. "0.08074558" */
  free: decimalSchema,
  /** e.g. "0.00000000" */
  freeze: decimalSchema,
  /** e.g. "0.00000000" */
  ipoable: decimalSchema,
  /** e.g. "0.00000000" */
  ipoing: decimalSchema,
  /** e.g. false */
  isLegalMoney: z.boolean(),
  /** e.g. "0.00000000" */
  locked: decimalSchema,
  /** e.g. "Bitcoin" */
  name: z.string(),
})

export const fundingAssetSchema = z.object({
  /** e.g. "USDT" */
  asset: z.string(),
  /** avalible balance | "1" */
  free: decimalSchema,
  /** locked asset | e.g. "0" */
  locked: decimalSchema,
  /** freeze asset | e.g. "0" */
  freeze: decimalSchema,
  /** e.g. "0" */
  withdrawing: decimalSchema,
  /** e.g. "0.00000091" */
  btcValuation: decimalSchema,
})

export const futureAssetSchema = z.object({
  /** unique account code | e.g. "SgsR" */
  accountAlias: z.string(),
  /** asset name | e.g. "USDT" */
  asset: z.string(),
  /** wallet balance | e.g. "122607.35137903" */
  balance: decimalSchema,
  /** crossed wallet balance | e.g. "23.72469206" */
  crossWalletBalance: decimalSchema,
  /** unrealized profit of crossed positions | e.g. "0.00000000" */
  crossUnPnl: z
    .string()
    .regex(/^\-?\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** available balance | e.g. "23.72469206" */
  availableBalance: decimalSchema,
  // /** maximum amount for transfer out | e.g. "23.72469206" */
  // maxWithdrawAmount: z
  //   .string()
  //   .regex(/^\d+(\.\d+)?$/)
  //   .transform((v) => createBigDecimal(v)),
  // /** whether the asset can be used as margin in Multi-Assets mode | e.g. true */
  // marginAvailable: z.boolean(),
  /** e.g. 1617939110373 */
  updateTime: z.number().int(),
})

export const marginAssetSchema = z.object({
  /** e.g. "BTC" */
  asset: z.string(),
  /** e.g. "0.00000000" */
  borrowed: decimalSchema,
  /** e.g. "0.00499500" */
  free: decimalSchema,
  /** e.g. "0.00000000" */
  interest: decimalSchema,
  /** e.g. "0.00000000" */
  locked: decimalSchema,
  /** e.g. "0.00499500" */
  netAsset: decimalSchema,
})

export const simpleEarnFlexiblePositionSchema = z.object({
  /** e.g. "75.46000000" */
  totalAmount: decimalSchema,
  /** e.g. "USDT" */
  asset: z.string(),
  /** e.g. "BETH" */
  airDropAsset: z.string().optional(),
  /** e.g. "232.23123213" */
  collateralAmount: decimalSchema,
  /** e.g. "USDT001" */
  productId: z.string(),
  /** e.g. "0.22759183" */
  cumulativeBonusRewards: decimalSchema,
  /** e.g. "0.22759183" */
  cumulativeRealTimeRewards: decimalSchema,
  /** e.g. "0.45459183" */
  cumulativeTotalRewards: decimalSchema,
})

export const simpleEarnLockedPositionSchema = z.object({
  /** e.g. "123123" */
  positionId: z.union([z.string(), z.number()]),
  /** e.g. "Axs*90" */
  projectId: z.string(),
  /** e.g. "AXS" */
  asset: z.string(),
  /** e.g. "122.09202928" */
  amount: decimalSchema,
  /** e.g. "1646182276000" */
  purchaseTime: z.union([z.string(), z.number()]),
  /** e.g. "60" */
  duration: z.union([z.string(), z.number()]),
  /** e.g. "4" */
  accrualDays: z.union([z.string(), z.number()]),
  /** e.g. "AXS" */
  rewardAsset: z.string(),
  /** e.g. "0.23" */
  APY: z.string().optional(),
  /** e.g. true */
  isRenewable: z.boolean().optional(),
  /** e.g. true */
  isAutoRenew: z.boolean().optional(),
  /** e.g. "1732182276000" */
  redeemDate: z.string().optional(),
})
